import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

class TagsNews extends Component {
    componentDidMount() {
        this.props.getAllTags();
    }

    _mapTags() {
        const tags = this.props.dataTags;

        return tags.map((data, indx) => (
            <LazyLoad className="containerLazy" height={50} key={indx} offset={500}>
                <Button className="linkTags" title={`Todas as noticias da tag: ${data.n}`} to={`/noticias/tags/${data.u}`}>
                    {data.n}
                </Button>
            </LazyLoad>
        ));
    }

    render() {
        return (
            <section className="SectionTags">
                <header>
                    <h1>Tags</h1>
                    <p className="pageSubtitle">Veja todas as tags utilizadas nas notícias da rádio Antena 1</p>
                </header>
                <div className="containerTags">
                    {this._mapTags()}
                </div>
            </section>
        );
    }
}

TagsNews.propTypes = exact({
    getAllTags: PropTypes.func,
    dataTags: PropTypes.array,
});

export default TagsNews;
